import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

import ResourceList from '../../components/ResourceList.jsx';
import ResourceForm from '../../components/ResourceForm.jsx';
import { SUPERADMIN_RESOURCES } from './resources';

const BASE = '/super-admin';

/** /super-admin/:resource — list view. */
export function SuperAdminResourceList() {
  const { resource: slug } = useParams();
  const resource = SUPERADMIN_RESOURCES[slug];
  if (!resource) return <Navigate to={BASE} replace />;
  return <ResourceList resource={resource} basePath={BASE} />;
}

/** /super-admin/:resource/new — create view. */
export function SuperAdminResourceCreate() {
  const { resource: slug } = useParams();
  const resource = SUPERADMIN_RESOURCES[slug];
  if (!resource) return <Navigate to={BASE} replace />;
  return <ResourceForm resource={resource} basePath={BASE} mode="create" />;
}

/** /super-admin/:resource/:id/edit — edit view. */
export function SuperAdminResourceEdit() {
  const { resource: slug } = useParams();
  const resource = SUPERADMIN_RESOURCES[slug];
  if (!resource) return <Navigate to={BASE} replace />;
  return <ResourceForm resource={resource} basePath={BASE} mode="edit" />;
}
